import {post} from "@/axios/request";

export const getUserInfo = uid => {
  return post("/hsp_identity/api/identity/shandong/info", {
    uid
  })
}
